'use strict';

class changeLang {

    run() {
        this.changeSelectLangUrl();
    }

    changeSelectLangUrl() {
        $(document).ready(() => {
            var storeLocatorChangeLangUrl = '#';
            if ($('.store-detail').length) {
                storeLocatorChangeLangUrl = $('.store-detail').attr('data-changeLangUrl');
            } else if ($('.stores-list').length) {
                storeLocatorChangeLangUrl = $('.stores-list').attr('data-changeLangUrl');
            }
            $('.select-lang-content .lang-list').attr('data-url', storeLocatorChangeLangUrl);
        });
    }

}

const ChangeLang = new changeLang();
ChangeLang.run();


// WEBPACK FOOTER //
// ./assets/scripts/storelocator/changeLang.js